// This config contains NAME-SPACE for each module of ENDPOINTS config
export const ModulesMap = {
	LAND_DOCUMENT_TYPES: 'land_document_types',
	LAND_DOCUMENTS: 'land_documents',
	EQUIPMENT_REGISTRATIONS: 'equipment_registrations',
	EQUIPMENT_FACTPLACES: 'equipment_factplaces',
	INCIDENT_TAGS: 'incident_tags',
	INCIDENT_COMMENTS: 'incidents_comments',
	INCIDENTS: 'incidents',
	INCIDENTS_MY_WORKS_TO_ADMINISTRATE_INCIDENTS: 'incidents_my_works_to_administrate_incidents',
	OPERATIONAL_MATERIALS: 'operational_materials',
	REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROLS: 'regulations_stages_plan_works_qualiti_controls',
	REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENTS: 'regulations_stages_plan_works_service_payments',
	REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENTS: 'regulations_stages_plan_works_staff_payments',
	REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUPS: 'regulations_stages_plan_works_staff_groups',
	REGULATIONS_STAGES_PLAN_WORKS_PRODUCTS: 'regulations_stages_plan_works_products',
	REGULATIONS_STAGES_PLAN_WORKS_MATERIALS: 'regulations_stages_plan_works_materials',
	WORK_REPORT_DOCUMENTS: 'work_report_documents',
	REGULATIONS_STAGE_TAGS: 'regulation_stage_tags',
	WORKS_SERVICE_PAYMENT_RATE_NORMS: 'works_service_payment_rates_norms',
	WORKS_MATERIAL_PRODUCTION_RATE_NORMS: 'works_materials_production_norms',
	MAPS: 'maps',
	TRIPS: 'trips',
	POSITION_DEVICES: 'positionDevices',
	WORKS_COST_CATEGORIES: 'works_cost_categories',
	REGULATION_TAGS: 'regulation_tags',
	EQUIPMENT_GROUPS: 'equipment_groups',
	STAFF_GROUPS: 'staff_groups',
	STAFF_DEPARTMENTS: 'staff_departments',
	STAFF_AND_MACHINERY_CARDS: 'staff_and_machinery_cards',
	CACHE: 'cache',
	USER: 'user',
	COMPANY: 'company',
	COMPANY_FUEL_SETTINGS: 'company_fuel_settings',
	FIELDS: 'fields',
	AUTH: 'auth',
	PRESETS: 'presets',
	MACHINES: 'machines',
	STAFF: 'staff',
	EQUIPMENT: 'equipment',
	INFRASTRUCTURES: 'infrastructures',
	INFRASTRUCTURE_TYPES: 'infrastructure_types',
	INFRASTRUCTURE_DOCUMENTS: 'infrastructure_documents',
	INFRASTRUCTURE_PLEDGES: 'infrastructure_pledges',
	INFRASTRUCTURE_REGISTRATIONS: 'infrastructure_registrations',
	INFRASTRUCTURE_TAGS: 'infrastructures_tags',
	INFRASTRUCTURE_PHOTOS: 'infrastructure_photos',
	LEGAL_ENTITIES: 'legal_entities',
	DEVICES: 'devices',
	SENSORS: 'sensors',
	DEVICE_MOUNTS: 'device_mounts',
	CLUSTERS: 'field_clusters',
	WEIGHT_STATIONS: 'weight_stations',
	PARTNERS: 'partners',
	AGGREGATE_CARDS: 'aggregate_cards',
	MATERIALS: 'materials',
	MATERIALS_CATEGORIES: 'materials_categories',
	MATERIALS_TAGS: 'materials_tags',
	FIELDS_TAGS: 'fields_tags',
	GPS_SOURCES: 'gps_sources',
	IDENTITY_CARDS: 'identity_cards',
	IDENTITY_MOUNTS: 'identity_mounts',
	MACHINES_GROUPS: 'machine_groups',
	STAFF_ROLES: 'staff_roles',
	MACHINE_FUEL_TANKS: 'fuel_tanks',
	MACHINE_BRIGADE: 'brigade',
	MACHINE_DOCUMENTS: 'documents',
	MACHINE_PHOTOS: 'photos',
	MACHINE_PLEDGES: 'pledges',
	MACHINE_TRANSFERS: 'transfers',
	COUNTERPARTIES: 'counterparties',
	COUNTERPARTIES_GROUPS: 'counterparties_groups',
	FUEL: 'fuel',
	FUEL_STATIONS: 'fuel_stations',
	FUEL_STATION_EVENTS: 'fuel_station_events',
	FUEL_STATION_RAW_EVENTS: 'fuel_station_raw_events',
	FUEL_STATION_GUNS: 'fuel_station_guns',
	WORKS_CATEGORIES: 'works_categories',
	WORKS: 'works',
	WORKS_MATERIAL_CONSUMPTION_RATE_NORMS: 'works_materials_consumption_norms',
	WORKS_PRODUCTIVITY_NORMS: 'works_productivity_norms',
	WORKS_QUALITY_NORMS: 'works_quality_norms',
	REGULATIONS_APPLICATION_AREA: 'regulations_application_area',
	CROPS: 'crops',
	WORKS_STAFF_PAYMENT_RATES_NORMS: 'works_staff_payment_rates_norms',
	POSITIONS_MACHINES: 'positions_machines',
	EVENTS: 'events',
	EQUIPMENT_PHOTOS: 'equipment_photos',
	WORK_REPORT_MEASURES: 'work_report_measures',
	WORK_REPORT_PHOTOS: 'work_report_photos',
	WORK_REPORT_LINKS: 'work_report_links',
	REGULATIONS_TARGET_PRODUCTS: 'regulations_target_products',
	REGULATIONS_METRICS: 'regulations_metrics',
	REGULATIONS_STAGES: 'regulations_stages',
	REGULATIONS_STAGES_PLAN_WORKS: 'regulations_stages_plan_works',
	MATERIALS_PHOTOS: 'materials_photos',
	MATERIALS_COSTS: 'materials_costs',
	FINANCE_GROUPS: 'finance_groups',
	FINANCE_CATEGORIES: 'finance_categories',
	FINANCE_TAGS: 'finance_tags',
	BUSINESS_PROCESSES: 'business_processes',
	NOTIFICATIONS: 'notifications',
	REGULATION_BASE_FINANCE_ATTRIBUTION: 'regulation_base_finance_attribution',
	REGULATION_PLAN_WORK_FINANCE_ATTRIBUTION: 'regulation_plan_work_finance_attribution',
	REPORTS: 'reports',
	REPORTS_DONE_WORKS_COSTS: 'reports_done_works_costs',
	REPORTS_DONE_WORKS: 'reports_done_works',
	REPORTS_MANUFACTURED_MATERIALS: 'reports_manufactured_materials',
	REPORTS_QUALITY_CONTROLS: 'reports_quality_controls',
	REPORTS_SERVICE_PAYMENTS: 'reports_service_payments',
	REPORTS_STAFF_PAYMENTS: 'reports_staff_payments',
	REPORTS_FINANCE_BY_CATEGORIES: 'reports_finance_by_categories',
	REPORTS_FINANCE_BY_DESTINATION: 'reports_finance_by_destination',
	REPORTS_FINANCE_BY_WORK_TYPE: 'reports_finance_by_work_type',
	REPORTS_FINANCE_EFFICIENCY: 'reports_finance_efficiency',
	REPORTS_FINANCE_PRODUCTS: 'reports_finance_products',
	REPORTS_STAGES_PROGRESS: 'reports_stages_progress',
	REPORTS_STAGES_PROGRESS_WITH_WORKS: 'reports_stages_progress_with_works',
	REPORTS_FINANCE_BY_MATERIALS_CATEGORIES: 'reports_finance_by_materials_categories',
	REPORTS_FINANCE_BY_ROLES: 'reports_finance_by_roles',
	REPORTS_FINANCE_BY_SERVICES: 'reports_finance_by_services',
	REPORTS_FINANCE_BY_WORK_CATEGORIES: 'reports_finance_by_work_categories',
	DONE_WORKS_BRIGADE: 'done_works_brigade',
	DONE_WORKS_CALCULATION_VOLUME_METRICS: 'done_works_calculation_volume_metrics',
	DONE_WORKS_DOCUMENTS: 'done_works_documents',
	DONE_WORKS_FINANCE_ATTRIBUTION: 'done_works_finance_attribution',
	DONE_WORKS_LINKS: 'done_works_links',
	DONE_WORKS_MEASURES: 'done_works_measures',
	DONE_WORKS_PHOTOS: 'done_works_photos',
	DONE_WORKS: 'done_works',
	DONE_WORKS_CONTROL_METRICS: 'done_works_control_metrics',
	REGULATIONS: 'regulations',
	REGULATIONS_STAGES_PLAN_WORKS_RECOMENDED_MACHINES: 'regulations_stages_plan_works_recomended_machines',
	REGULATIONS_STAGES_PLAN_WORKS_RECOMENDED_EQUIPMENT: 'regulations_stages_plan_works_recomended_equipment',
	REGULATIONS_STAGES_PLAN_WORKS_RECOMENDED_COUNTERPARTIES: 'regulations_stages_plan_works_recomended_counterparties',
	REGULATIONS_STAGES_PLAN_WORKS_RECOMENDED_STAFF: 'regulations_stages_plan_works_recomended_staff',
	REGULATIONS_FINANCE_PRODUCTIVITY: 'regulations_finance_productivity',
	REPORTS_REPORTING: 'reportsReporting',
	REGULATION_STAGE_FINANCE_ATTRIBUTION: 'regulation_stage_finance_attribution',
	DONE_WORKS_MANUFACTURED_MATERIALS: 'done_works_manufactured_materials',
	DONE_WORKS_OPERATIONAL_MATERIALS: 'done_works_operational_materials',
	DONE_WORKS_SERVICES: 'done_works_services',
	DONE_WORKS_CALCULATION_MATERIALS_METRICS: 'done_works_calculation_materials_metrics',
	DONE_WORKS_IN_PROGRESS_FIELD_WORKS: 'done_works_in_progress_field_works',
	BUSINESS_PROCESSES_ACTIVE_PLAN_WORKS: 'business_processes_active_plan_works',
	RULES_BREAKING: 'rules_breaking',
	WORK_ORDERS: 'work_orders',
	WORK_ORDERS_MATERIALS: 'work_orders_materials',
	WORK_ORDERS_PRODUCTS: 'work_orders_products',
	WORK_ORDERS_QUALITY_CONTROLS: 'work_orders_quality_control',
	DONE_WORKS_DONE_FIELD_WORKS: 'done_work_done_field_works',
	WEIGHT_TRANSACTIONS: 'weight_transactions',
	WEIGHING_COMBINER_TICKETS: 'weighing_combiner_tickets',
	CROP_WRITEOFFS: 'crop_writeoffs',
	MACHINERY_WRITEOFFS: 'machinery_writeoffs',
	DONE_WORKS_MY_WORKS_TO_ADMINISTRATE: 'done_works_my_works_to_administrate',
	DONE_WORKS_MY_WORKS_TO_CONTROL: 'done_works_my_works_to_control',
	DONE_WORKS_MY_WORKS_TO_DO: 'done_works_my_works_to_do',
	WORKS_SHIFT: 'works_shifts',
	ORDER_GENERATORS_FIELDS_WORKS: 'order_generators_fields_works',
	ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS: 'order_generators_fields_works_plan_works',
	ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS: 'order_generators_fields_works_executors',
	ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADES: 'order_generators_fields_works_executors_brigades',
	ORDER_GENERATORS_FIELDS_WORKS_MATERIALS: 'order_generators_fields_works_materials',
	ORDER_GENERATORS_FIELDS_WORKS_PRODUCTS: 'order_generators_fields_works_products',
	ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROLS: 'order_generators_fields_works_quality_controls',
	ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENTS: 'order_generators_fields_works_staff_payments',
	ORDER_GENERATORS_FIELDS_WORKS_SERVICES: 'order_generators_fields_works_services',
	MACHINE_REGISTRATIONS: 'machine_registrations',
	MACHINE_FACT_PLACES: 'machine_fact_places',
	LOGISTIC_ROUTES: 'logistic_routes',
	LOGISTIC_ROUTE_TAGS: 'logistic_tags',
	LOGISTIC_ROUTES_GEO_ZONES: 'logistic_routes_geo_zones',
	REPORT_DEVICE_MOUNTS: 'report_device_mounts',
	DONE_WORKS_ALL_FIELD_WORKS: 'done_works_all_field_works',
	DONE_WORKS_ALL_LOGISTIC_WORKS: 'done_works_all_logistic_works',
	DONE_WORKS_ALL_HAND_MADE_WORKS: 'done_works_all_hand_made_works',
	REGULATIONS_ALL_PLAN_WORKS: 'regulations_all_plan_works',
	MACHINES_ICONS: 'machine_icons',
	CARGOS: 'cargos',
	CARGO_ITEMS: 'cargo_items',
	CARGO_TAGS: 'cargo_tags',
	API_USAGES: 'api_usages',
	LANDS: 'lands',
	LAND_PLEDGES: 'land_pledges',
	LAND_ACTIONS: 'land_actions',
	LAND_CATEGORIES: 'land_categories',
	LAND_OWNERSHIP_TYPES: 'land_ownership_types',
	LAND_PURPOSES: 'land_purposes',
	EQUIPMENT_DOCUMENTS: 'equipment_documents',
	EQUIPMENT_PLEDGES: 'equipment_pledges',
	LANDS_CADASTRAL_CASES: 'land_cadastral_cases',
	CUSTOM_GEO_ZONES: 'custom_geo_zones',
	CUSTOM_GEO_ZONES_CATEGORIES: 'custom_geo_zones_categories',
	BUSINESS_PROCESS_BASE_EXECUTORS: 'business_process_base_executors',
	ELEVATORS_WAYBILL_REGISTERS: 'elevators_waybill_registers',
	ELEVATORS_INVENTORY_BALANCE_LINES: 'elevators_inventory_balance_lines',
	ELEVATORS_OPERATIONS: 'elevators_operations',
	ELEVATORS_LABORATORY_ANALYSES: 'elevators_laboratory_analyses',
}

// This config contains whole only ENDPOINTS and MOCK Config SCHEMA
export const ModulesConfigMap = {
	[ModulesMap.LAND_DOCUMENT_TYPES]: {
		GET_LAND_DOCUMENT_TYPES: 'getLandDocumentTypes',
		GET_LAND_DOCUMENT_TYPE: 'getLandDocumentType',
		GET_LAND_DOCUMENT_TYPE_PREVIEW: 'getLandDocumentTypePreview',
		GET_LAND_DOCUMENT_TYPE_POPUP: 'getLandDocumentTypePopup',
		CREATE_LAND_DOCUMENT_TYPE: 'createLandDocumentType',
		PUT_LAND_DOCUMENT_TYPE: 'putLandDocumentType',
		PATCH_LAND_DOCUMENT_TYPE: 'patchLandDocumentType',
		DELETE_LAND_DOCUMENT_TYPE: 'deleteLandDocumentType',
	},
	[ModulesMap.LAND_DOCUMENTS]: {
		GET_LAND_DOCUMENTS: 'getLandDocuments',
		GET_LAND_DOCUMENT: 'getLandDocument',
		GET_LAND_DOCUMENT_PREVIEW: 'getLandDocumentPreview',
		GET_LAND_DOCUMENT_POPUP: 'getLandDocumentPopup',
		CREATE_LAND_DOCUMENT: 'createLandDocument',
		PUT_LAND_DOCUMENT: 'putLandDocument',
		PATCH_LAND_DOCUMENT: 'patchLandDocument',
		DELETE_LAND_DOCUMENT: 'deleteLandDocument',
	},
	[ModulesMap.EQUIPMENT_FACTPLACES]: {
		GET_EQUIPMENT_FACTPLACES: 'getEquipmentFactplaces',
		CREATE_EQUIPMENT_FACTPLACE: 'createEquipmentFactplace',
		GET_EQUIPMENT_FACTPLACE: 'getEquipmentFactplace',
		PATCH_EQUIPMENT_FACTPLACE: 'patchEquipmentFactplace',
		PUT_EQUIPMENT_FACTPLACE: 'putEquipmentFactplace',
		DELETE_EQUIPMENT_FACTPLACE: 'deleteEquipmentFactplace',
	},
	[ModulesMap.EQUIPMENT_REGISTRATIONS]: {
		GET_EQUIPMENT_REGISTRATIONS: 'getEquipmentRegistrations',
		CREATE_EQUIPMENT_REGISTRATION: 'createEquipmentRegistration',
		GET_EQUIPMENT_REGISTRATION: 'getEquipmentRegistration',
		PATCH_EQUIPMENT_REGISTRATION: 'patchEquipmentRegistration',
		PUT_EQUIPMENT_REGISTRATION: 'putEquipmentRegistration',
		DELETE_EQUIPMENT_REGISTRATION: 'deleteEquipmentRegistration',
	},
	[ModulesMap.INCIDENT_COMMENTS]: {
		GET_INCIDENT_COMMENTS: 'getIncidentComments',
		CREATE_INCIDENT_COMMENT: 'createIncidentComment',
		GET_INCIDENT_COMMENT: 'getIncidentComment',
		PATCH_INCIDENT_COMMENT: 'patchIncidentComment',
		PUT_INCIDENT_COMMENT: 'putIncidentComment',
		DELETE_INCIDENT_COMMENT: 'deleteIncidentComment',
	},
	[ModulesMap.INCIDENTS]: {
		GET_INCIDENTS: 'getIncidents',
		GET_INCIDENT_PREVIEW: 'getIncidentPreview',
		GET_INCIDENT_POPUP: 'getIncidentPopup',
		CREATE_INCIDENT: 'createIncident',
		GET_INCIDENT: 'getIncident',
		PATCH_INCIDENT: 'patchIncident',
		PATCH_INCIDENT_CLOSE: 'patchIncidentClose',
		PUT_INCIDENT: 'putIncident',
		DELETE_INCIDENT: 'deleteIncident',
	},
	[ModulesMap.INCIDENTS_MY_WORKS_TO_ADMINISTRATE_INCIDENTS]: {
		GET_INCIDENTS_MY_WORKS_TO_ADMINISTRATE_INCIDENTS: 'getIncidentsMyWorksToAdministrateIncidents',
	},
	[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROLS]: {
		GET_REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROLS: 'getRegulationsStagesPlanWorksQualitiControls',
		GET_REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROL_PREVIEW: 'getRegulationsStagesPlanWorksQualitiControlPreview',
		GET_REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROL_POPUP: 'getRegulationsStagesPlanWorksQualitiControlPopup',
		CREATE_REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROL: 'createRegulationsStagesPlanWorksQualitiControl',
		GET_REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROL: 'getRegulationsStagesPlanWorksQualitiControl',
		PATCH_REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROL: 'patchRegulationsStagesPlanWorksQualitiControl',
		PUT_REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROL: 'putRegulationsStagesPlanWorksQualitiControl',
		DELETE_REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROL: 'deleteRegulationsStagesPlanWorksQualitiControl',
	},
	[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENTS]: {
		GET_REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENTS: 'getRegulationsStagesPlanWorksServicePayments',
		GET_REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENT_PREVIEW: 'getRegulationsStagesPlanWorksServicePaymentPreview',
		GET_REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENT_POPUP: 'getRegulationsStagesPlanWorksServicePaymentPopup',
		CREATE_REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENT: 'createRegulationsStagesPlanWorksServicePayment',
		GET_REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENT: 'getRegulationsStagesPlanWorksServicePayment',
		PATCH_REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENT: 'patchRegulationsStagesPlanWorksServicePayment',
		PUT_REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENT: 'putRegulationsStagesPlanWorksServicePayment',
		DELETE_REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENT: 'deleteRegulationsStagesPlanWorksServicePayment',
	},
	[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENTS]: {
		GET_REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENTS: 'getRegulationsStagesPlanWorksStaffPayments',
		GET_REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENT_PREVIEW: 'getRegulationsStagesPlanWorksStaffPaymentPreview',
		GET_REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENT_POPUP: 'getRegulationsStagesPlanWorksStaffPaymentPopup',
		CREATE_REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENT: 'createRegulationsStagesPlanWorksStaffPayment',
		GET_REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENT: 'getRegulationsStagesPlanWorksStaffPayment',
		PATCH_REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENT: 'patchRegulationsStagesPlanWorksStaffPayment',
		PUT_REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENT: 'putRegulationsStagesPlanWorksStaffPayment',
		DELETE_REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENT: 'deleteRegulationsStagesPlanWorksStaffPayment',
	},
	[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUPS]: {
		GET_REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUPS: 'getRegulationsStagesPlanWorksStaffGroups',
		GET_REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUP_PREVIEW: 'getRegulationsStagesPlanWorksStaffGroupPreview',
		GET_REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUP_POPUP: 'getRegulationsStagesPlanWorksStaffGroupPopup',
		CREATE_REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUP: 'createRegulationsStagesPlanWorksStaffGroup',
		GET_REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUP: 'getRegulationsStagesPlanWorksStaffGroup',
		PATCH_REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUP: 'patchRegulationsStagesPlanWorksStaffGroup',
		PUT_REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUP: 'putRegulationsStagesPlanWorksStaffGroup',
		DELETE_REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUP: 'deleteRegulationsStagesPlanWorksStaffGroup',
	},
	[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_PRODUCTS]: {
		GET_REGULATIONS_STAGES_PLAN_WORKS_PRODUCTS: 'getRegulationsStagesPlanWorksProducts',
		GET_REGULATIONS_STAGES_PLAN_WORKS_PRODUCT_PREVIEW: 'getRegulationsStagesPlanWorksProductPreview',
		GET_REGULATIONS_STAGES_PLAN_WORKS_PRODUCT_POPUP: 'getRegulationsStagesPlanWorksProductPopup',
		CREATE_REGULATIONS_STAGES_PLAN_WORKS_PRODUCT: 'createRegulationsStagesPlanWorksProduct',
		GET_REGULATIONS_STAGES_PLAN_WORKS_PRODUCT: 'getRegulationsStagesPlanWorksProduct',
		PATCH_REGULATIONS_STAGES_PLAN_WORKS_PRODUCT: 'patchRegulationsStagesPlanWorksProduct',
		PUT_REGULATIONS_STAGES_PLAN_WORKS_PRODUCT: 'putRegulationsStagesPlanWorksProduct',
		DELETE_REGULATIONS_STAGES_PLAN_WORKS_PRODUCT: 'deleteRegulationsStagesPlanWorksProduct',
	},
	[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_MATERIALS]: {
		GET_REGULATIONS_STAGES_PLAN_WORKS_MATERIALS: 'getRegulationsStagesPlanWorksMaterials',
		GET_REGULATIONS_STAGES_PLAN_WORKS_MATERIAL_PREVIEW: 'getRegulationsStagesPlanWorksMaterialPreview',
		GET_REGULATIONS_STAGES_PLAN_WORKS_MATERIAL_POPUP: 'getRegulationsStagesPlanWorksMaterialPopup',
		CREATE_REGULATIONS_STAGES_PLAN_WORKS_MATERIAL: 'createRegulationsStagesPlanWorksMaterial',
		GET_REGULATIONS_STAGES_PLAN_WORKS_MATERIAL: 'getRegulationsStagesPlanWorksMaterial',
		PATCH_REGULATIONS_STAGES_PLAN_WORKS_MATERIAL: 'patchRegulationsStagesPlanWorksMaterial',
		PUT_REGULATIONS_STAGES_PLAN_WORKS_MATERIAL: 'putRegulationsStagesPlanWorksMaterial',
		DELETE_REGULATIONS_STAGES_PLAN_WORKS_MATERIAL: 'deleteRegulationsStagesPlanWorksMaterial',
	},
	[ModulesMap.WORK_REPORT_DOCUMENTS]: {
		GET_WORK_REPORT_DOCUMENTS: 'getWorkReportDocuments',
		GET_WORK_REPORT_DOCUMENT: 'getWorkReportDocument',
		CREATE_WORK_REPORT_DOCUMENT: 'createWorkReportDocument',
		PUT_WORK_REPORT_DOCUMENT: 'putWorkReportDocument',
		PATCH_WORK_REPORT_DOCUMENT: 'patchWorkReportDocument',
		DELETE_WORK_REPORT_DOCUMENT: 'deleteWorkReportDocument',
	},
	[ModulesMap.TRIPS]: {
		GET_TRIPS: 'getTrips',
		GET_TRIP: 'getTrip',
		GET_TRIPS_POPUP: 'getTripsPopup',
		GET_TRIPS_PREVIEW: 'getTripsPreview',
	},
	[ModulesMap.POSITION_DEVICES]: {
		GET_POSITION_DEVICES: 'getPositionDevices',
		GET_POSITION_DEVICE: 'getPositionDevice',
	},
	[ModulesMap.WORKS_SERVICE_PAYMENT_RATE_NORMS]: {
		GET_WORKS_SERVICE_PAYMENT_RATE_NORMS: 'getWorksServicePaymentRateNorms',
		GET_WORKS_SERVICE_PAYMENT_RATE_NORM: 'getWorksServicePaymentRateNorm',
		CREATE_WORKS_SERVICE_PAYMENT_RATE_NORM: 'createWorksServicePaymentRateNorm',
		PUT_WORKS_SERVICE_PAYMENT_RATE_NORM: 'putWorksServicePaymentRateNorm',
		PATCH_WORKS_SERVICE_PAYMENT_RATE_NORM: 'patchWorksServicePaymentRateNorm',
		DELETE_WORKS_SERVICE_PAYMENT_RATE_NORM: 'deleteWorksServicePaymentRateNorm',
	},
	[ModulesMap.WORKS_MATERIAL_PRODUCTION_RATE_NORMS]: {
		GET_WORKS_MATERIAL_PRODUCTION_RATE_NORMS: 'getWorksMaterialProductionRateNorms',
		GET_WORKS_MATERIAL_PRODUCTION_RATE_NORM: 'getWorksMaterialProductionRateNorm',
		CREATE_WORKS_MATERIAL_PRODUCTION_RATE_NORM: 'createWorksMaterialProductionRateNorm',
		PUT_WORKS_MATERIAL_PRODUCTION_RATE_NORM: 'putWorksMaterialProductionRateNorm',
		PATCH_WORKS_MATERIAL_PRODUCTION_RATE_NORM: 'patchWorksMaterialProductionRateNorm',
		DELETE_WORKS_MATERIAL_PRODUCTION_RATE_NORM: 'deleteWorksMaterialProductionRateNorm',
	},
	[ModulesMap.STAFF_AND_MACHINERY_CARDS]: {
		GET_AVAILABLE_STAFF_AND_MACHINERY_CARDS: 'getAvailableStaffAndMachineryCards',
	},
	[ModulesMap.CACHE]: {
		GET_CACHE_HASHES: 'getCashHashes',
	},
	[ModulesMap.USER]: {
		GET_DATA: 'getData',
		GET_PERMISSIONS: 'getPermissions',
		GET_POPULATION: 'getPopulation',
		GET_CACHE_VERSION: 'getCahceVersion',

		GET_CURRENT_USER: 'getCurrentUser',
		GET_AVAILABLE_COMPANIES: 'fetchAvailableCompanies',

		PUT_USER: 'putUser',
		PATCH_USER: 'patchUser',
		SET_PASSWORD: 'setPassword',
	},
	[ModulesMap.COMPANY]: {
		CREATE_COMPANY: 'createCompany',
		GET_COMPANY: 'getCompanyProfileById',
		PATCH_COMPANY: 'patchCompany',
		GET_AVAILABLE_USER_COMPANY_PERMISSIONS: 'getAvailableUserCompanyPermissions',
	},
	[ModulesMap.COMPANY_FUEL_SETTINGS]: {
		GET_COMPANY_FUEL_SETTINGS: 'getCompanyFuelSettings',
		PATCH_COMPANY_FUEL_SETTINGS: 'patchCompanyFuelSettings',
	},
	[ModulesMap.AUTH]: {
		REGISTER_USER: 'registerUser',
		LOGIN_USER: 'loginUser',
		RESEND_EMAIL_CONFIRMATION: 'resendEmailConfirmation',
	},
	[ModulesMap.PRESETS]: {
		GET_PRESETS: 'getPresets',
		GET_MULTIPLE_PRESETS: 'getMultiplePresets',
		DELETE_PRESET: 'deletePreset',
		EDIT_PRESET: 'editPreset',
		PATCH_PRESET: 'patchPreset',
		CREATE_PRESET: 'createPreset',
		CLONE_TO_COMPANY_PRESET: 'cloneToCompanyPreset',
		CHANGE_PRESETS_ORDER: 'changePresetsOrder',
	},
	[ModulesMap.MAPS]: {
		GET_MAPS_TELEMATIC_CHART_DATA: 'getMapsTelematicChartData',
		GET_MAPS_CROPS: 'getMapsCrops',
		GET_MAPS_CROPS_EXTENDED_INFO: 'getMapsCropsExtendedInfo',
		GET_MAPS_EVENTS: 'getMapsEvents',
		GET_MAPS_MOVEMENT_POINTS: 'getMapsMovementPoints',
		GET_MAPS_TRACKS: 'getMapsTracks',
		GET_MAPS_TRACKS_EXTENDED_INFO: 'getMapsTracksExtendedInfo',
		GET_MAPS_TRACKS_MOVED_MACHINES: 'getMapsTracksMovedMachines',
		GET_MAPS_TRACKS_REALTIME_DATA: 'getMapsTracksRealtimeData',
		GET_MAPS_FIELD_WORKS: 'getMapsFieldWorks',
		GET_MAPS_LOGISTIC_WORKS: 'getMapsLogisticWorks',
		GET_MAPS_PREVIEW: 'getMapsPreview',
		GET_MACHINE_TRACK: 'getMachineTrack',
		GET_RELATED_FIELD_WORKS: 'getRelatedFieldWorks',
		GET_MACHINE_WIDE_TRACK: 'getMachineWideTrack',
		GET_MACHINE_WIDE_TRACK_CROSSED_CROPS: 'getMachineWideTrackCrossedCrops',
		GET_MACHINE_TRACK_POINTS: 'getMachineTrackPoints',
		GET_SATELLITE_IMAGE_DATES: 'getSatelliteImageDates',
		GET_SATELLITE_IMAGE_DATE_DYNAMIC: 'getSatelliteImageDateDynamic',
		GET_SATELLITE_IMAGES: 'getSatelliteImages',
		GET_SATELLITE_IMAGE: 'getSatelliteImage',
		GET_SATELLITE_IMAGES_STATS: 'getSatelliteImagesStats',
		GET_DONE_WORK_GEOMETRIES: 'getDoneWorkGeometries',
	},
	[ModulesMap.MACHINES]: {
		GET_AVAIABLE_MACHINES: 'getAvailableMachines',
		CREATE_MACHINE: 'createMachine',
		GET_PREVIEW_MACHINE: 'getAvailableMachine',
		GET_POPUP_MACHINE: 'getPopupMachine',
		DELETE_MACHINE: 'deleteMachine',
		GET_MACHINE: 'getMachine',
		EDIT_MACHINE: 'editMachine',
		PUT_MACHINE: 'putMachine',
		GET_SENSORS_VALUES: 'getSensorValues',
		GET_RAW_GPS_PARAMS: 'getRawGpsParams',
	},
	[ModulesMap.MACHINE_BRIGADE]: {
		GET_BRIGADES: 'getMachineBrigades',
		CREATE_BRIGADE: 'createMachineBrigade',
		GET_BRIGADE: 'getMachineBrigade',
		PATCH_BRIGADE: 'patchMachineBrigade',
		PUT_BRIGADE: 'putMachineBrigade',
		DELETE_BRIGADE: 'deleteMachineBrigade',
	},
	[ModulesMap.MACHINE_PHOTOS]: {
		GET_PHOTOS: 'getMachinePhotos',
		CREATE_PHOTO: 'createMachinePhoto',
		GET_PHOTO: 'getMachinePhoto',
		PATCH_PHOTO: 'patchMachinePhoto',
		PUT_PHOTO: 'putMachinePhoto',
		DELETE_PHOTO: 'deleteMachinePhoto',
	},
	[ModulesMap.MACHINE_TRANSFERS]: {
		GET_TRANSFERS: 'getMachineTransfers',
		CREATE_TRANSFER: 'createMachineTransfer',
		GET_TRANSFER: 'getMachineTransfer',
		PATCH_TRANSFER: 'patchMachineTransfer',
		PUT_TRANSFER: 'putMachineTransfer',
		DELETE_TRANSFER: 'deleteMachineTransfer',
	},
	[ModulesMap.STAFF]: {
		GET_AVAILABLE_STAFF: 'getAvailableStaff',
		CREATE_STAFF: 'createStaff',
		GET_STAFF: 'getStaff',
		GET_STAFF_POPUP: 'getStaffPopup',
		GET_STAFF_PREVIEW: 'getStaffPreview',
		PATCH_STAFF: 'patchStaff',
		PUT_STAFF: 'putStaff',
		DELETE_STAFF: 'deleteStaff',
		SET_PERMISSION: 'setPermission',
	},
	[ModulesMap.EQUIPMENT]: {
		GET_AVAILABLE_EQUIPMENT: 'getAvailableEquipment',
		GET_EQUIPMENT: 'getEquipment',
		GET_PREVIEW_EQUIPMENT: 'getPreviewEquipment',
		GET_POPUP_EQUIPMENT: 'getPopupEquipment',
		CREATE_EQUIPMENT: 'createEquipment',
		PATCH_EQUIPMENT: 'patchEquipment',
		PUT_EQUIPMENT: 'putEquipment',
		DELETE_EQUIPMENT: 'deleteEquipment',
	},
	[ModulesMap.INFRASTRUCTURE_TYPES]: {
		GET_AVAILABLE_INFRASTRUCTURE_TYPES: 'getAvailableInfrastructureTypes',
		GET_INFRASTRUCTURE_TYPES_PREVIEW: 'getInfrastructureTypesPreview',
		GET_INFRASTRUCTURE_TYPE: 'getInfrastructureType',
		CREATE_INFRASTRUCTURE_TYPES: 'createInfrastructureTypes',
		PATCH_INFRASTRUCTURE_TYPES: 'patchInfrastructureTypes',
		PUT_INFRASTRUCTURE_TYPES: 'putInfrastructureTypes',
		DELETE_INFRASTRUCTURE_TYPES: 'deleteInfrastructureTypes',
	},
	[ModulesMap.INFRASTRUCTURE_TAGS]: {
		GET_INFRASTRUCTURE_TAGS: 'getInfrastructureTags',
		GET_INFRASTRUCTURE_TAG: 'getInfrastructureTag',
		GET_INFRASTRUCTURE_TAGS_PREVIEW: 'getInfrastructureTagsPreview',
		CREATE_INFRASTRUCTURE_TAGS: 'createInfrastructureTags',
		PUT_INFRASTRUCTURE_TAGS: 'putInfrastructureTags',
		PATCH_INFRASTRUCTURE_TAGS: 'patchInfrastructureTags',
		DELETE_INFRASTRUCTURE_TAGS: 'deleteInfrastructureTags',
	},
	[ModulesMap.INFRASTRUCTURE_PHOTOS]: {
		GET_PHOTOS: 'getInfrastructurePhotos',
		CREATE_PHOTO: 'createInfrastructurePhoto',
		GET_PHOTO: 'getInfrastructurePhoto',
		PATCH_PHOTO: 'patchInfrastructurePhoto',
		PUT_PHOTO: 'putInfrastructurePhoto',
		DELETE_PHOTO: 'deleteInfrastructurePhoto',
	},
	[ModulesMap.PARTNERS]: {
		GET_AVAILABLE_PARTNERS: 'getAvailablePartners',
	},
	[ModulesMap.AGGREGATE_CARDS]: {
		GET_AVAILABLE_AGGREGATE_CARDS: 'getAvailableAggregateCards',
	},
	[ModulesMap.GPS_SOURCES]: {
		GET_GPS_SOURCES: 'getGpsSources',
		CREATE_GPS_SOURCE: 'createGpsSource',
		GET_GPS_SOURCE: 'getGpsSource',
		PATCH_GPS_SOURCE: 'patchGpsSource',
	},
	[ModulesMap.IDENTITY_CARDS]: {
		GET_IDENTITY_CARDS: 'getIdentityCards',
		GET_IDENTITY_CARDS_PREVIEW: 'getIdentityCardsPreview',
		CREATE_IDENTITY_CARD: 'createIdentityCard',
		DELETE_IDENTITY_CARD: 'deleteIdentityCard',
		GET_IDENTITY_CARD: 'getIdentityCard',
		PATCH_IDENTITY_CARD: 'patchIdentityCard',
	},
	[ModulesMap.IDENTITY_MOUNTS]: {
		GET_IDENTITY_MOUNTS: 'getIdentityMounts',
		GET_IDENTITY_MOUNT: 'getIdentityMount',
		CREATE_IDENTITY_MOUNT: 'createIdentityMount',
		PATCH_IDENTITY_MOUNT: 'patchIdentityMount',
		DELETE_IDENTITY_MOUNT: 'deleteIdentityMount',
	},
	[ModulesMap.FUEL]: {
		GET_FUEL: 'getFuel',
		GET_FUEL_PREVIEW: 'getFuelPreview',
	},
	[ModulesMap.FUEL_STATIONS]: {
		GET_FUEL_STATIONS: 'getFuelStations',
		POST_FUEL_STATION: 'postFuelStation',
		GET_FUEL_STATION: 'getFuelStation',
		GET_FUEL_STATION_POPUP: 'getFuelStationPopup',
		GET_FUEL_STATION_PREVIEW: 'getFuelStationPreview',
		PUT_FUEL_STATION: 'putFuelStation',
		PATCH_FUEL_STATION: 'patchFuelStation',
		DELETE_FUEL_STATION: 'deleteFuelStation',
	},
	[ModulesMap.FUEL_STATION_EVENTS]: {
		GET_FUEL_STATION_EVENTS: 'getFuelStationEvents',
		PATCH_FUEL_STATION_EVENT: 'patchFuelStationEvent',
		GET_FUEL_STATION_EVENT: 'getFuelStationEvent',
		GET_FUEL_STATION_EVENT_POPUP: 'getFuelStationEventPopup',
		GET_FUEL_STATION_EVENT_PREVIEW: 'getFuelStationEventPreview',
	},
	[ModulesMap.FUEL_STATION_RAW_EVENTS]: {
		GET_FUEL_STATION_RAW_EVENTS: 'getFuelStationRawEvents',
		GET_FUEL_STATION_RAW_EVENT: 'getFuelStationRawEvent',
		GET_FUEL_STATION_RAW_EVENT_PREVIEW: 'getFuelStationRawEventPreview',
	},
	[ModulesMap.FUEL_STATION_GUNS]: {
		GET_FUEL_STATION_GUNS: 'getFuelStationGuns',
		POST_FUEL_STATION_GUN: 'postFuelStationGun',
		GET_FUEL_STATION_GUN: 'getFuelStationGun',
		PUT_FUEL_STATION_GUN: 'putFuelStationGun',
		PATCH_FUEL_STATION_GUN: 'patchFuelStationGun',
		DELETE_FUEL_STATION_GUN: 'deleteFuelStationGun',
		GET_FUEL_STATION_GUN_POPUP: 'getFuelStationGunPopup',
		GET_FUEL_STATION_GUN_PREVIEW: 'getFuelStationGunPreview',
	},
	[ModulesMap.WORKS_MATERIAL_CONSUMPTION_RATE_NORMS]: {
		GET_WORKS_MATERIAL_CONSUMPTION_RATE_NORMS: 'getWorksMaterialConsumptionRateNorms',
		GET_WORKS_MATERIAL_CONSUMPTION_RATE_NORM: 'getWorksMaterialConsumptionRateNorm',
		CREATE_WORKS_MATERIAL_CONSUMPTION_RATE_NORM: 'createWorksMaterialConsumptionRateNorm',
		PUT_WORKS_MATERIAL_CONSUMPTION_RATE_NORM: 'putWorksMaterialConsumptionRateNorm',
		PATCH_WORKS_MATERIAL_CONSUMPTION_RATE_NORM: 'patchWorksMaterialConsumptionRateNorm',
		DELETE_WORKS_MATERIAL_CONSUMPTION_RATE_NORM: 'deleteWorksMaterialConsumptionRateNorm',
	},
	[ModulesMap.WORKS_PRODUCTIVITY_NORMS]: {
		GET_WORKS_PRODUCTIVITY_NORMS: 'getWorksProductivityNorms',
		GET_WORKS_PRODUCTIVITY_NORM: 'getWorksProductivityNorm',
		CREATE_WORKS_PRODUCTIVITY_NORM: 'createWorksProductivityNorm',
		PUT_WORKS_PRODUCTIVITY_NORM: 'putWorksProductivityNorm',
		PATCH_WORKS_PRODUCTIVITY_NORM: 'patchWorksProductivityNorm',
		DELETE_WORKS_PRODUCTIVITY_NORM: 'deleteWorksProductivityNorm',
	},
	[ModulesMap.WORKS_QUALITY_NORMS]: {
		GET_WORKS_QUALITY_NORMS: 'getWorksQualityNorms',
		GET_WORKS_QUALITY_NORM: 'getWorksQualityNorm',
		CREATE_WORKS_QUALITY_NORM: 'createWorksQualityNorm',
		PUT_WORKS_QUALITY_NORM: 'putWorksQualityNorm',
		PATCH_WORKS_QUALITY_NORMS: 'patchWorksQualityNorms',
		DELETE_WORKS_QUALITY_NORM: 'deleteWorksQualityNorm'
	},
	[ModulesMap.REGULATIONS_APPLICATION_AREA]: {
		GET_REGULATIONS_APPLICATION_AREAS: 'getRegulationsApplicationAreas',
		CREATE_REGULATIONS_APPLICATION_AREA: 'createRegulationsApplicationArea',
		GET_REGULATIONS_APPLICATION_AREA: 'getRegulationsApplicationArea',
		PATCH_REGULATIONS_APPLICATION_AREA: 'patchRegulationsApplicationArea',
		PUT_REGULATIONS_APPLICATION_AREA: 'putRegulationsApplicationArea',
		DELETE_REGULATIONS_APPLICATION_AREA: 'deleteRegulationsApplicationArea',
	},
	[ModulesMap.WORKS_STAFF_PAYMENT_RATES_NORMS]: {
		GET_WORKS_STAFF_PAYMENT_RATES_NORMS: 'getWorksStaffPaymentRatesNorms',
		GET_WORKS_STAFF_PAYMENT_RATES_NORM: 'getWorksStaffPaymentRatesNorm',
		CREATE_WORKS_STAFF_PAYMENT_RATES_NORM: 'createWorksStaffPaymentRatesNorm',
		PUT_WORKS_STAFF_PAYMENT_RATES_NORM: 'putWorksStaffPaymentRatesNorm',
		PATCH_WORKS_STAFF_PAYMENT_RATES_NORM: 'patchWorksStaffPaymentRatesNorm',
		DELETE_WORKS_STAFF_PAYMENT_RATES_NORM: 'deleteWorksStaffPaymentRatesNorm'
	},
	[ModulesMap.CROPS]: {
		GET_CROPS: 'getCrops',
		GET_CROP_POPUP: 'getCropPopup',
		GET_CROP_PREVIEW: 'getCropPreview',
		GET_CROP: 'getCrop',
		CREATE_CROP: 'createCrop',
		PUT_CROP: 'putCrop',
		PATCH_CROP: 'patchCrop',
		DELETE_CROP: 'deleteCrop',
	},
	[ModulesMap.POSITIONS_MACHINES]: {
		GET_POSITIONS_MACHINES: 'getPositionsMachines',
		GET_POSITIONS_MACHINE: 'getPositionsMachine',
		GET_POSITIONS_ON_TIME_POINT: 'getPositionsMachineOnTimePoint',
	},
	[ModulesMap.EVENTS]: {
		GET_EVENTS: 'getEvents',
		GET_EVENT: 'getEvent',
		GET_EVENT_PREVIEW: 'getEventPreview',
		PATCH_EVENT: 'patchEvent',
	},
	[ModulesMap.EQUIPMENT_PHOTOS]: {
		GET_PHOTOS: 'getEquipmentPhotos',
		CREATE_PHOTO: 'createEquipmentPhoto',
		GET_PHOTO: 'getEquipmentPhoto',
		PATCH_PHOTO: 'patchEquipmentPhoto',
		PUT_PHOTO: 'putEquipmentPhoto',
		DELETE_PHOTO: 'deleteEquipmentPhoto',
	},
	[ModulesMap.WORK_REPORT_MEASURES]: {
		GET_WORK_REPORT_MEASURES: 'getWorkReportMeasures',
		CREATE_WORK_REPORT_MEASURE: 'createWorkReportMeasure',
		GET_WORK_REPORT_MEASURE: 'getWorkReportMeasure',
		PUT_WORK_REPORT_MEASURE: 'putWorkReportMeasure',
		PATCH_WORK_REPORT_MEASURES: 'patchWorkReportMeasures',
		DELETE_WORK_REPORT_MEASURE: 'deleteWorkReportMeasure',
	},
	[ModulesMap.REGULATIONS_TARGET_PRODUCTS]: {
		GET_REGULATIONS_TARGET_PRODUCTS: 'getRegulationsProducts',
		GET_REGULATIONS_TARGET_PRODUCT_PREVIEW: 'getRegulationsTargetProductPreview',
		GET_REGULATIONS_TARGET_PRODUCT_POPUP: 'getRegulationsTargetProductPopup',
		CREATE_REGULATIONS_TARGET_PRODUCT: 'createRegulationsProduct',
		GET_REGULATIONS_TARGET_PRODUCT: 'getRegulationsProduct',
		PATCH_REGULATIONS_TARGET_PRODUCT: 'patchRegulationsProduct',
		PUT_REGULATIONS_TARGET_PRODUCT: 'putRegulationsProduct',
		DELETE_REGULATIONS_TARGET_PRODUCT: 'deleteRegulationsProduct',
	},
	[ModulesMap.REGULATIONS_METRICS]: {
		GET_REGULATIONS_METRICS: 'getRegulationsMetrics',
		GET_REGULATIONS_METRIC_PREVIEW: 'getRegulationsMetricPreview',
		GET_REGULATIONS_METRIC_POPUP: 'getRegulationsMetricPopup',
		CREATE_REGULATIONS_METRIC: 'createRegulationsMetric',
		GET_REGULATIONS_METRIC: 'getRegulationsMetric',
		PATCH_REGULATIONS_METRIC: 'patchRegulationsMetric',
		PUT_REGULATIONS_METRIC: 'putRegulationsMetric',
		DELETE_REGULATIONS_METRIC: 'deleteRegulationsMetric',
	},
	[ModulesMap.REGULATIONS_STAGES]: {
		GET_REGULATIONS_STAGES: 'getRegulationsStages',
		GET_REGULATIONS_STAGE_PREVIEW: 'getRegulationsStagePreview',
		GET_REGULATIONS_STAGE_POPUP: 'getRegulationsStagePopup',
		CREATE_REGULATIONS_STAGE: 'createRegulationsStage',
		GET_REGULATIONS_STAGE: 'getRegulationsStage',
		PATCH_REGULATIONS_STAGE: 'patchRegulationsStage',
		PUT_REGULATIONS_STAGE: 'putRegulationsStage',
		DELETE_REGULATIONS_STAGE: 'deleteRegulationsStage',
	},
	[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS]: {
		GET_REGULATIONS_STAGES_PLAN_WORKS: 'getRegulationsStagesPlanWorks',
		GET_REGULATIONS_STAGES_PLAN_WORK_PREVIEW: 'getRegulationsStagesPlanWorkPreview',
		GET_REGULATIONS_STAGES_PLAN_WORK_POPUP: 'getRegulationsStagesPlanWorkPopup',
		GET_REGULATIONS_STAGES_PLAN_WORK_EXTENDED_POPUP: 'getRegulationsStagesPlanWorkExtendedPopup',
		GET_REGULATIONS_STAGES_PLAN_WORK_DONE_WORKS: 'getRegulationsStagesPlanWorkDoneWorks',
		CREATE_REGULATIONS_STAGES_PLAN_WORK: 'createRegulationsStagesPlanWork',
		GET_REGULATIONS_STAGES_PLAN_WORK: 'getRegulationsStagesPlanWork',
		PATCH_REGULATIONS_STAGES_PLAN_WORK: 'patchRegulationsStagesPlanWork',
		PUT_REGULATIONS_STAGES_PLAN_WORK: 'putRegulationsStagesPlanWork',
		DELETE_REGULATIONS_STAGES_PLAN_WORK: 'deleteRegulationsStagesPlanWork',
	},
	[ModulesMap.BUSINESS_PROCESSES]: {
		GET_BUSINESS_PROCESSES: 'getBusinessProcesses',
		GET_BUSINESS_PROCESSES_MAIN_INFO: 'getBusinessProcessesMainInfo',
		CREATE_BUSINESS_PROCESS: 'createBusinessProcess',
		GET_BUSINESS_PROCESS: 'getBusinessProcess',
		PUT_BUSINESS_PROCESS: 'putBusinessProcess',
		PATCH_BUSINESS_PROCESS: 'patchBusinessProcess',
		DELETE_BUSINESS_PROCESS: 'deleteBusinessProcess',
		GET_BUSINESS_PROCESS_PREVIEW: 'getBusinessProcessPreview',
		GET_BUSINESS_PROCESS_POPUP: 'getBusinessProcessPopup',
		CREATE_BUSINESS_PROCESS_CROP: 'createBusinessProcessCrop',
		PUT_BUSINESS_PROCESS_CROP: 'putBusinessProcessCrop',
		PATCH_BUSINESS_PROCESS_CROP: 'patchBusinessProcessCrop',
		MULTI_SET_CULTURE: 'multiSetCulture',

		GET_BUSINESS_PROCESSES_ACTIVE_STAGES: 'getBusinessProcessesActiveStages',
		GET_BUSINESS_PROCESSES_ACTIVE_STAGE: 'getBusinessProcessesActiveStage',
		GET_BUSINESS_PROCESSES_ACTIVE_STAGE_POPUP: 'getBusinessProcessesActiveStagePopup',
		GET_BUSINESS_PROCESSES_ACTIVE_STAGE_PREVIEW: 'getBusinessProcessesActiveStagePreview',

		GET_BUSINESS_PROCESSES_FINANCE_BY_CATEGORIES: 'getBusinessProcessesFinanceByCategories',
		GET_BUSINESS_PROCESSES_FINANCE_BY_DESTINATION: 'getBusinessProcessesFinanceByDestination',
		GET_BUSINESS_PROCESSES_FINANCE_BY_WORK_TYPES: 'getBusinessProcessesFinanceByWorkTypes',

		CREATE_BUSINESS_PROCESS_UNIVERSAL: 'createBusinessProcessUniversal',
		PUT_BUSINESS_PROCESS_UNIVERSAL: 'putBusinessProcessUniversal',
		PATCH_BUSINESS_PROCESS_UNIVERSAL: 'patchBusinessProcessUniversal',
	},
	[ModulesMap.REGULATION_BASE_FINANCE_ATTRIBUTION]: {
		GET_REGULATION_BASE_FINANCE_ATTRIBUTIONS: 'getRegulationBaseFinanceAttributions',
		CREATE_REGULATION_BASE_FINANCE_ATTRIBUTION: 'createRegulationBaseFinanceAttribution',
		GET_REGULATION_BASE_FINANCE_ATTRIBUTION: 'getRegulationBaseFinanceAttribution',
		PUT_REGULATION_BASE_FINANCE_ATTRIBUTION: 'putRegulationBaseFinanceAttribution',
		PATCH_REGULATION_BASE_FINANCE_ATTRIBUTION: 'patchRegulationBaseFinanceAttribution',
		DELETE_REGULATION_BASE_FINANCE_ATTRIBUTION: 'deleteRegulationBaseFinanceAttribution',
		GET_REGULATION_BASE_FINANCE_ATTRIBUTION_PREVIEW: 'getRegulationBaseFinanceAttributionPreview',
		GET_REGULATION_BASE_FINANCE_ATTRIBUTION_POPUP: 'getRegulationBaseFinanceAttributionPopup',
	},
	[ModulesMap.NOTIFICATIONS]: {
		GET_NOTIFICATIONS: 'getNotifications',
		PATCH_NOTIFICATIONS_MARK_ALL_READ: 'patchNotificationsMarkAllRead',
		PATCH_NOTIFICATIONS_MARK_READ_STATUS: 'patchNotificationsMarkReadStatus',
		GET_NOTIFICATIONS_UNREAD_COUNT: 'getNotificationsUnreadCount',
		GET_NOTIFICATION: 'getNotification',
		PATCH_NOTIFICATION: 'patchNotification',
		GET_NOTIFICATION_PREVIEW: 'patchNotificationPreview',
		GET_NOTIFICATIONS_SETTINGS: 'getNotificationsSettings',
		PATCH_NOTIFICATIONS_SETTINGS: 'patchNotificationsSettings',
	},
	[ModulesMap.REGULATION_PLAN_WORK_FINANCE_ATTRIBUTION]: {
		GET_REGULATION_PLAN_WORK_FINANCE_ATTRIBUTIONS: 'getRegulationPlanWorkFinanceAttributions',
		CREATE_REGULATION_PLAN_WORK_FINANCE_ATTRIBUTION: 'createRegulationPlanWorkFinanceAttribution',
		GET_REGULATION_PLAN_WORK_FINANCE_ATTRIBUTION: 'getRegulationPlanWorkFinanceAttribution',
		PUT_REGULATION_PLAN_WORK_FINANCE_ATTRIBUTION: 'putRegulationPlanWorkFinanceAttribution',
		PATCH_REGULATION_PLAN_WORK_FINANCE_ATTRIBUTION: 'patchRegulationPlanWorkFinanceAttribution',
		DELETE_REGULATION_PLAN_WORK_FINANCE_ATTRIBUTION: 'deleteRegulationPlanWorkFinanceAttribution',
	},
	[ModulesMap.REPORTS]: {
		GET_REPORTS_CULTURES: 'getReportsCultures',
		GET_REPORTS_FIELDS: 'getReportsFields',
		GET_REPORTS_MATERIALS_VOLUMES: 'getReportsMaterialsVolumes',
		GET_REPORTS_PRODUCT_VOLUMES: 'getReportsProductVolumes',
		GET_REPORTS_RELATED_OBJECTS: 'getReportsRelatedObjects',
	},
	[ModulesMap.REPORTS_DONE_WORKS_COSTS]: {
		GET_REPORTS_DONE_WORKS_COSTS: 'getReportsDoneWorksCosts',
		GET_REPORTS_DONE_WORKS_COST: 'getReportsDoneWorksCost',
		GET_REPORTS_DONE_WORKS_COST_PREVIEW: 'getReportsDoneWorksCostPreview',
	},
	[ModulesMap.REPORTS_DONE_WORKS]: {
		GET_REPORTS_DONE_WORKS: 'getReportsDoneWorks',
		GET_REPORTS_DONE_WORK: 'getReportsDoneWork',
		GET_REPORTS_DONE_WORK_PREVIEW: 'getReportsDoneWorkPreview',
	},
	[ModulesMap.REPORTS_QUALITY_CONTROLS]: {
		GET_REPORTS_QUALITY_CONTROLS: 'getReportsQualityControls',
		GET_REPORTS_QUALITY_CONTROL: 'getReportsQualityControl',
		GET_REPORTS_QUALITY_CONTROL_PREVIEW: 'getReportsQualityControlPreview',

	},
	[ModulesMap.REPORTS_SERVICE_PAYMENTS]: {
		GET_REPORTS_SERVICE_PAYMENTS: 'getReportsServicePayments',
		GET_REPORTS_SERVICE_PAYMENT: 'getReportsServicePayment',
		GET_REPORTS_SERVICE_PAYMENT_PREVIEW: 'getReportsServicePaymentPreview',
	},
	[ModulesMap.REPORTS_STAFF_PAYMENTS]: {
		GET_REPORTS_STAFF_PAYMENTS: 'getReportsStaffPayments',
		GET_REPORTS_STAFF_PAYMENT: 'getReportsStaffPayment',
		GET_REPORTS_STAFF_PAYMENT_PREVIEW: 'getReportsStaffPaymentPreview',
	},
	[ModulesMap.REPORTS_FINANCE_BY_CATEGORIES]: {
		GET_REPORTS_FINANCE_BY_CATEGORIES: 'getReportsFinanceByCategories',
	},
	[ModulesMap.REPORTS_FINANCE_BY_DESTINATION]: {
		GET_REPORTS_FINANCE_BY_DESTINATION: 'getReportsFinanceByDestination',
	},
	[ModulesMap.REPORTS_FINANCE_BY_WORK_TYPE]: {
		GET_REPORTS_FINANCE_BY_WORK_TYPE: 'getReportsFinanceByWorkTypes',
	},
	[ModulesMap.REPORTS_FINANCE_EFFICIENCY]: {
		GET_REPORTS_FINANCE_EFFICIENCY: 'getReportsFinanceEfficiency',
	},
	[ModulesMap.REPORTS_FINANCE_PRODUCTS]: {
		GET_REPORTS_FINANCE_PRODUCTS: 'getReportsFinanceProducts',
	},
	[ModulesMap.REPORTS_STAGES_PROGRESS]: {
		GET_REPORTS_STAGES_PROGRESS: 'getReportsStagesProgress',
	},
	[ModulesMap.REPORTS_STAGES_PROGRESS_WITH_WORKS]: {
		GET_REPORTS_STAGES_PROGRESS_WITH_WORKS: 'getReportsStagesProgressWithWorks',
	},
	[ModulesMap.REPORTS_FINANCE_BY_MATERIALS_CATEGORIES]: {
		GET_REPORTS_FINANCE_BY_MATERIALS_CATEGORIES: 'getReportsFinanceByMaterialsCategories',
	},
	[ModulesMap.REPORTS_FINANCE_BY_ROLES]: {
		GET_REPORTS_FINANCE_BY_ROLES: 'getReportsFinanceByRoles',
	},
	[ModulesMap.REPORTS_FINANCE_BY_SERVICES]: {
		GET_REPORTS_FINANCE_BY_SERVICES: 'getReportsFinanceByServices',
	},
	[ModulesMap.REPORTS_FINANCE_BY_WORK_CATEGORIES]: {
		GET_REPORTS_FINANCE_BY_WORK_CATEGORIES: 'getReportsFinanceByWorkCategories',
	},
	[ModulesMap.DONE_WORKS_BRIGADE]: {
		GET_DONE_WORKS_BRIGADES: 'getDoneWorksBrigades',
		CREATE_DONE_WORKS_BRIGADE: 'createDoneWorksBrigade',
		GET_DONE_WORKS_BRIGADE: 'getDoneWorksBrigade',
		PUT_DONE_WORKS_BRIGADE: 'putDoneWorksBrigade',
		PATCH_DONE_WORKS_BRIGADE: 'patchDoneWorksBrigade',
		DELETE_DONE_WORKS_BRIGADE: 'deleteDoneWorksBrigade',
		GET_DONE_WORKS_BRIGADE_PREVIEW: 'getDoneWorksBrigadePreview',
		GET_DONE_WORKS_BRIGADE_POPUP: 'getDoneWorksBrigadePopup',
	},
	[ModulesMap.DONE_WORKS_CALCULATION_VOLUME_METRICS]: {
		GET_DONE_WORKS_CALCULATION_VOLUME_METRICS: 'getDoneWorksCalculationVolumeMetrics',
		CREATE_DONE_WORKS_CALCULATION_VOLUME_METRIC: 'createDoneWorksCalculationVolumeMetric',
		GET_DONE_WORKS_CALCULATION_VOLUME_METRIC: 'getDoneWorksCalculationVolumeMetric',
		PUT_DONE_WORKS_CALCULATION_VOLUME_METRIC: 'putDoneWorksCalculationVolumeMetric',
		PATCH_DONE_WORKS_CALCULATION_VOLUME_METRIC: 'patchDoneWorksCalculationVolumeMetric',
		PATCH_DONE_WORKS_CALCULATION_VOLUME_METRIC_INTERVALS: 'patchDoneWorksCalculationVolumeMetricIntervals',
		PATCH_DONE_WORKS_CALCULATION_VOLUME_METRIC_BULK_UPDATE: 'patchDoneWorksCalculationVolumeMetricBulkUpdate',
		DELETE_DONE_WORKS_CALCULATION_VOLUME_METRIC: 'deleteDoneWorksCalculationVolumeMetric',
		GET_DONE_WORKS_CALCULATION_VOLUME_METRIC_PREVIEW: 'getDoneWorksCalculationVolumeMetricPreview',
		GET_DONE_WORKS_CALCULATION_VOLUME_METRIC_POPUP: 'getDoneWorksCalculationVolumeMetricPopup',
	},
	[ModulesMap.DONE_WORKS_DOCUMENTS]: {
		GET_DONE_WORKS_DOCUMENTS: 'getDoneWorksDocuments',
		CREATE_DONE_WORKS_DOCUMENT: 'createDoneWorksDocument',
		GET_DONE_WORKS_DOCUMENT: 'getDoneWorksDocument',
		PUT_DONE_WORKS_DOCUMENT: 'putDoneWorksDocument',
		PATCH_DONE_WORKS_DOCUMENT: 'patchDoneWorksDocument',
		DELETE_DONE_WORKS_DOCUMENT: 'deleteDoneWorksDocument',
		GET_DONE_WORKS_DOCUMENT_PREVIEW: 'getDoneWorksDocumentPreview',
		GET_DONE_WORKS_DOCUMENT_POPUP: 'getDoneWorksDocumentPopup',
	},
	[ModulesMap.DONE_WORKS_FINANCE_ATTRIBUTION]: {
		GET_DONE_WORKS_FINANCE_ATTRIBUTIONS: 'getDoneWorksFinanceAttributions',
		CREATE_DONE_WORKS_FINANCE_ATTRIBUTION: 'createDoneWorksFinanceAttribution',
		GET_DONE_WORKS_FINANCE_ATTRIBUTION: 'getDoneWorksFinanceAttribution',
		PUT_DONE_WORKS_FINANCE_ATTRIBUTION: 'putDoneWorksFinanceAttribution',
		PATCH_DONE_WORKS_FINANCE_ATTRIBUTION: 'patchDoneWorksFinanceAttribution',
		DELETE_DONE_WORKS_FINANCE_ATTRIBUTION: 'deleteDoneWorksFinanceAttribution',
		GET_DONE_WORKS_FINANCE_ATTRIBUTION_PREVIEW: 'getDoneWorksFinanceAttributionPreview',
		GET_DONE_WORKS_FINANCE_ATTRIBUTION_POPUP: 'getDoneWorksFinanceAttributionPopup',
	},
	[ModulesMap.DONE_WORKS_LINKS]: {
		GET_DONE_WORKS_LINKS: 'getDoneWorksLinks',
		CREATE_DONE_WORKS_LINK: 'createDoneWorksLink',
		GET_DONE_WORKS_LINK: 'getDoneWorksLink',
		PUT_DONE_WORKS_LINK: 'putDoneWorksLink',
		PATCH_DONE_WORKS_LINK: 'patchDoneWorksLink',
		DELETE_DONE_WORKS_LINK: 'deleteDoneWorksLink',
		GET_DONE_WORKS_LINK_PREVIEW: 'getDoneWorksLinkPreview',
		GET_DONE_WORKS_LINK_POPUP: 'getDoneWorksLinkPopup',
	},
	[ModulesMap.DONE_WORKS_MEASURES]: {
		GET_DONE_WORKS_MEASURES: 'getDoneWorksMeasures',
		CREATE_DONE_WORKS_MEASURE: 'createDoneWorksMeasure',
		GET_DONE_WORKS_MEASURE: 'getDoneWorksMeasure',
		PUT_DONE_WORKS_MEASURE: 'putDoneWorksMeasure',
		PATCH_DONE_WORKS_MEASURE: 'patchDoneWorksMeasure',
		PATCH_DONE_WORKS_MEASURE_BULK_UPDATE: 'patchDoneWorksMeasureBulkUpdate',
		POST_DONE_WORKS_MEASURE_BULK_CREATE: 'postDoneWorksMeasureBulkCreate',
		DELETE_DONE_WORKS_MEASURE: 'deleteDoneWorksMeasure',
		GET_DONE_WORKS_MEASURE_PREVIEW: 'getDoneWorksMeasurePreview',
		GET_DONE_WORKS_MEASURE_POPUP: 'getDoneWorksMeasurePopup',
	},
	[ModulesMap.DONE_WORKS_PHOTOS]: {
		GET_DONE_WORKS_PHOTOS: 'getDoneWorksPhotos',
		CREATE_DONE_WORKS_PHOTO: 'createDoneWorksPhoto',
		GET_DONE_WORKS_PHOTO: 'getDoneWorksPhoto',
		PUT_DONE_WORKS_PHOTO: 'putDoneWorksPhoto',
		PATCH_DONE_WORKS_PHOTO: 'patchDoneWorksPhoto',
		DELETE_DONE_WORKS_PHOTO: 'deleteDoneWorksPhoto',
		GET_DONE_WORKS_PHOTO_PREVIEW: 'getDoneWorksPhotoPreview',
		GET_DONE_WORKS_PHOTO_POPUP: 'getDoneWorksPhotoPopup',
	},
	[ModulesMap.DONE_WORKS]: {
		GET_DONE_WORKS: 'getDoneWorks',
		CREATE_DONE_WORK: 'createDoneWork',
		GET_DONE_WORK: 'getDoneWork',
		PUT_DONE_WORK: 'putDoneWork',
		PATCH_DONE_WORK: 'patchDoneWork',
		DELETE_DONE_WORK: 'deleteDoneWork',
		GET_DONE_WORK_PREVIEW: 'getDoneWorkPreview',
		GET_DONE_WORK_POPUP: 'getDoneWorkPopup',
	},
	[ModulesMap.DONE_WORKS_CONTROL_METRICS]: {
		PATCH_DONE_WORKS_CONTROL_METRIC: 'patchDoneWorksControlMetric',
		PATCH_DONE_WORKS_CONTROL_METRIC_BULK_UPDATE: 'patchDoneWorksControlMetricBulkUpdate',
		GET_DONE_WORKS_CONTROL_METRICS: 'getDoneWorksControlMetrics',
		GET_DONE_WORKS_CONTROL_METRIC_PREVIEW: 'getDoneWorksControlMetricPreview',
		GET_DONE_WORKS_CONTROL_METRIC_POPUP: 'getDoneWorksControlMetricPopup',
		CREATE_DONE_WORKS_CONTROL_METRIC: 'createDoneWorksControlMetric',
		GET_DONE_WORKS_CONTROL_METRIC: 'getDoneWorksControlMetric',
		PUT_DONE_WORKS_CONTROL_METRIC: 'putDoneWorksControlMetric',
		DELETE_DONE_WORKS_CONTROL_METRIC: 'deleteDoneWorksControlMetric',
	},
	[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_RECOMENDED_MACHINES]: {
		GET_REGULATIONS_STAGES_PLAN_WORKS_RECOMENDED_MACHINES: 'getRegulationsStagesPlanWorksRecomendedMachines',
	},
	[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_RECOMENDED_EQUIPMENT]: {
		GET_REGULATIONS_STAGES_PLAN_WORKS_RECOMENDED_EQUIPMENT: 'getRegulationsStagesPlanWorksRecomendedEquipment',
	},
	[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_RECOMENDED_COUNTERPARTIES]: {
		GET_REGULATIONS_STAGES_PLAN_WORKS_RECOMENDED_COUNTERPARTIES: 'getRegulationsStagesPlanWorksRecomendedCounterparties',
	},
	[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_RECOMENDED_STAFF]: {
		GET_REGULATIONS_STAGES_PLAN_WORKS_RECOMENDED_STAFF: 'getRegulationsStagesPlanWorksRecomendedStaff',
	},
	[ModulesMap.REGULATIONS_FINANCE_PRODUCTIVITY]: {
		GET_REGULATIONS_FINANCE_PRODUCTIVITY: 'getRegulationsFinanceProductivity',
	},
	[ModulesMap.REPORTS_REPORTING]: {
		GET_REPORTS_REPORTING: 'getReportsReporting',
		GET_REPORT_REPORTING: 'getReportReporting',
		GET_REPORT_REPORTING_PREVIEW: 'getReportReportingPreview',
	},
	[ModulesMap.REGULATION_STAGE_FINANCE_ATTRIBUTION]: {
		GET_REGULATION_STAGE_FINANCE_ATTRIBUTIONS: 'getRegulationStageFinanceAttributions',
		CREATE_REGULATION_STAGE_FINANCE_ATTRIBUTION: 'createRegulationStageFinanceAttribution',
		GET_REGULATION_STAGE_FINANCE_ATTRIBUTION: 'getRegulationStageFinanceAttribution',
		PUT_REGULATION_STAGE_FINANCE_ATTRIBUTION: 'putRegulationStageFinanceAttribution',
		PATCH_REGULATION_STAGE_FINANCE_ATTRIBUTION: 'patchRegulationStageFinanceAttribution',
		DELETE_REGULATION_STAGE_FINANCE_ATTRIBUTION: 'deleteRegulationStageFinanceAttribution',
	},
	[ModulesMap.DONE_WORKS_MANUFACTURED_MATERIALS]: {
		GET_DONE_WORKS_MANUFACTURED_MATERIALS: 'getDoneWorksManufacturedMaterials',
		CREATE_DONE_WORKS_MANUFACTURED_MATERIAL: 'createDoneWorksManufacturedMaterial',
		GET_DONE_WORKS_MANUFACTURED_MATERIAL: 'getDoneWorksManufacturedMaterial',
		PUT_DONE_WORKS_MANUFACTURED_MATERIAL: 'putDoneWorksManufacturedMaterial',
		PATCH_DONE_WORKS_MANUFACTURED_MATERIAL: 'patchDoneWorksManufacturedMaterial',
		DELETE_DONE_WORKS_MANUFACTURED_MATERIAL: 'deleteDoneWorksManufacturedMaterial',
		GET_DONE_WORKS_MANUFACTURED_MATERIAL_PREVIEW: 'getDoneWorksManufacturedMaterialPreview',
		GET_DONE_WORKS_MANUFACTURED_MATERIAL_POPUP: 'getDoneWorksManufacturedMaterialPopup',
	},
	[ModulesMap.DONE_WORKS_OPERATIONAL_MATERIALS]: {
		GET_DONE_WORKS_OPERATIONAL_MATERIALS: 'getDoneWorksOperationalMaterials',
		CREATE_DONE_WORKS_OPERATIONAL_MATERIAL: 'createDoneWorksOperationalMaterial',
		GET_DONE_WORKS_OPERATIONAL_MATERIAL: 'getDoneWorksOperationalMaterial',
		PUT_DONE_WORKS_OPERATIONAL_MATERIAL: 'putDoneWorksOperationalMaterial',
		PATCH_DONE_WORKS_OPERATIONAL_MATERIAL: 'patchDoneWorksOperationalMaterial',
		DELETE_DONE_WORKS_OPERATIONAL_MATERIAL: 'deleteDoneWorksOperationalMaterial',
		GET_DONE_WORKS_OPERATIONAL_MATERIAL_PREVIEW: 'getDoneWorksOperationalMaterialPreview',
		GET_DONE_WORKS_OPERATIONAL_MATERIAL_POPUP: 'getDoneWorksOperationalMaterialPopup',
	},
	[ModulesMap.DONE_WORKS_SERVICES]: {
		GET_DONE_WORKS_SERVICES: 'getDoneWorksServices',
		CREATE_DONE_WORKS_SERVICE: 'createDoneWorksService',
		GET_DONE_WORKS_SERVICE: 'getDoneWorksService',
		PUT_DONE_WORKS_SERVICE: 'putDoneWorksService',
		PATCH_DONE_WORKS_SERVICE: 'patchDoneWorksService',
		DELETE_DONE_WORKS_SERVICE: 'deleteDoneWorksService',
		GET_DONE_WORKS_SERVICE_PREVIEW: 'getDoneWorksServicePreview',
		GET_DONE_WORKS_SERVICE_POPUP: 'getDoneWorksServicePopup',
	},
	[ModulesMap.DONE_WORKS_CALCULATION_MATERIALS_METRICS]: {
		GET_DONE_WORKS_CALCULATION_MATERIALS_METRICS: 'getDoneWorksCalculationMaterialsMetrics',
		CREATE_DONE_WORKS_CALCULATION_MATERIALS_METRIC: 'createDoneWorksCalculationMaterialsMetric',
		GET_DONE_WORKS_CALCULATION_MATERIALS_METRIC: 'getDoneWorksCalculationMaterialsMetric',
		PUT_DONE_WORKS_CALCULATION_MATERIALS_METRIC: 'putDoneWorksCalculationMaterialsMetric',
		PATCH_DONE_WORKS_CALCULATION_MATERIALS_METRIC: 'patchDoneWorksCalculationMaterialsMetric',
		PATCH_DONE_WORKS_CALCULATION_MATERIALS_METRIC_BULK_UPDATE: 'patchDoneWorksCalculationMaterialsMetricBulkUpdate',
		DELETE_DONE_WORKS_CALCULATION_MATERIALS_METRIC: 'deleteDoneWorksCalculationMaterialsMetric',
		GET_DONE_WORKS_CALCULATION_MATERIALS_METRIC_PREVIEW: 'getDoneWorksCalculationMaterialsMetricPreview',
		GET_DONE_WORKS_CALCULATION_MATERIALS_METRIC_POPUP: 'getDoneWorksCalculationMaterialsMetricPopup',
	},
	[ModulesMap.DONE_WORKS_IN_PROGRESS_FIELD_WORKS]: {
		GET_IN_PROGRESS_FIELD_WORKS: 'getInProgressFieldWorks',
	},
	[ModulesMap.BUSINESS_PROCESSES_ACTIVE_PLAN_WORKS]: {
		GET_BUSINESS_PROCESSES_ACTIVE_PLAN_WORKS: 'getBusinessProcessesActivePlanWorks',
		GET_BUSINESS_PROCESSES_ACTIVE_PLAN_WORK: 'getBusinessProcessesActivePlanWork',
		GET_BUSINESS_PROCESSES_ACTIVE_PLAN_WORKS_PREVIEW: 'getBusinessProcessesActivePlanWorkPreview',
		GET_BUSINESS_PROCESSES_ACTIVE_PLAN_WORKS_POPUP: 'getBusinessProcessesActivePlanWorkPopup',
	},
	[ModulesMap.RULES_BREAKING]: {
		GET_RULES_BREAKING: 'getRulesBreaking',
		GET_RULE_BREAKING: 'getRuleBreaking',
	},
	[ModulesMap.WORK_ORDERS]: {
		GET_WORK_ORDERS: 'getWorkOrders',
		GET_WORK_ORDER: 'getWorkOrder',
		CREATE_WORK_ORDER: 'createWorkOrder',
		CREATE_FIELD_WORK_ORDER: 'createFieldWorkOrder',
		PUT_WORK_ORDER: 'putWorkOrder',
		PUT_CLOSE_FIELD_WORK_ORDER: 'putCloseFieldWorkOrder',
		PUT_UPDATE_FIELD_WORK_ORDER: 'putUpdateFieldWorkOrder',
		PATCH_WORK_ORDER: 'patchWorkOrder',
		PATCH_CLOSE_FIELD_WORK_ORDER: 'patchCloseFieldWorkOrder',
		PATCH_UPDATE_FIELD_WORK_ORDER: 'patchUpdateFieldWorkOrder',
		DELETE_WORK_ORDER: 'deleteWorkOrder',
		GET_WORK_ORDER_PREVIEW: 'getWorkOrderPreview',
		GET_WORK_ORDER_POPUP: 'getWorkOrderPopup',
		PATCH_WORK_ORDER_RECALCULATE: 'patchWorkOrderRecalculate',
		GET_WORK_ORDER_IS_CAN_BE_CLOSED: 'getWorkOrderIsCanBeClosed',
		CREATE_LOGISTIC_WORK_ORDER: 'createLogisticWorkOrder',
		PUT_CLOSE_LOGISTIC_WORK_ORDER: 'putCloseLogisticWorkOrder',
		PATCH_CLOSE_LOGISTIC_WORK_ORDER: 'patchCloseLogisticWorkOrder',
		PUT_UPDATE_LOGISTIC_WORK_ORDER: 'putUpdateLogisticWorkOrder',
		PATCH_UPDATE_LOGISTIC_WORK_ORDER: 'patchUpdateLogisticWorkOrder',
		CREATE_HAND_MADE_WORK_ORDER: 'createHandMadeWorkOrder',
		PATCH_HAND_MADE_WORK_ORDER: 'patchHandMadeWorkOrder',
		COPY_TO_ANOTHER_BRIGADE: 'copyToAnotherBrigade',
		COPY_TO_ANOTHER_PERIOD: 'copyToAnotherPeriod',
		COPY_TO_ANOTHER_PLAN_WORK: 'copyToAnotherPlanWork',
	},
	[ModulesMap.WORK_ORDERS_MATERIALS]: {
		GET_WORK_ORDERS_MATERIALS: 'getWorkOrdersMaterials',
		GET_WORK_ORDERS_MATERIAL: 'getWorkOrdersMaterial',
		CREATE_WORK_ORDERS_MATERIAL: 'createWorkOrdersMaterial',
		PUT_WORK_ORDERS_MATERIAL: 'putWorkOrdersMaterial',
		PATCH_WORK_ORDERS_MATERIAL: 'patchWorkOrdersMaterial',
		DELETE_WORK_ORDERS_MATERIAL: 'deleteWorkOrdersMaterial',
	},
	[ModulesMap.WORK_ORDERS_PRODUCTS]: {
		GET_WORK_ORDERS_PRODUCTS: 'getWorkOrdersProducts',
		GET_WORK_ORDERS_PRODUCT: 'getWorkOrdersProduct',
		CREATE_WORK_ORDERS_PRODUCT: 'createWorkOrdersProduct',
		PUT_WORK_ORDERS_PRODUCT: 'putWorkOrdersProduct',
		PATCH_WORK_ORDERS_PRODUCT: 'patchWorkOrdersProduct',
		DELETE_WORK_ORDERS_PRODUCT: 'deleteWorkOrdersProduct',
	},
	[ModulesMap.DONE_WORKS_DONE_FIELD_WORKS]: {
		GET_DONE_FIELD_WORKS: 'getDoneFieldWorks',
	},
	[ModulesMap.WEIGHING_COMBINER_TICKETS]: {
		GET_WEIGHING_COMBINER_TICKETS: 'getWeighingCombinerTickets',
		GET_WEIGHING_COMBINER_TICKET: 'getWeighingCombinerTicket',
		GET_WEIGHING_COMBINER_TICKET_PREVIEW: 'getWeighingCombinerTicketPreview',
	},
	[ModulesMap.DONE_WORKS_MY_WORKS_TO_ADMINISTRATE]: {
		GET_MY_WORKS_TO_ADMINISTRATE: 'getMyWorksToAdministrate',
	},
	[ModulesMap.DONE_WORKS_MY_WORKS_TO_CONTROL]: {
		GET_MY_WORKS_TO_CONTROL: 'getMyWorksToControl',
	},
	[ModulesMap.DONE_WORKS_MY_WORKS_TO_DO]: {
		GET_MY_WORKS_TO_DO: 'getMyWorksToDo',
	},
	[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS]: {
		GET_ORDER_GENERATORS_FIELDS_WORKS: 'getOrderGeneratorsFieldsWorks',
		GET_ORDER_GENERATORS_FIELDS_WORK: 'getOrderGeneratorsFieldsWork',
		CREATE_ORDER_GENERATORS_FIELDS_WORK: 'createOrderGeneratorsFieldsWork',
		PUT_ORDER_GENERATORS_FIELDS_WORK: 'putOrderGeneratorsFieldsWork',
		PATCH_ORDER_GENERATORS_FIELDS_WORK: 'patchOrderGeneratorsFieldsWork',
		DELETE_ORDER_GENERATORS_FIELDS_WORK: 'deleteOrderGeneratorsFieldsWork',
		GET_ORDER_GENERATORS_FIELDS_WORK_PREVIEW: 'getOrderGeneratorsFieldsWorkPreview',
		GET_ORDER_GENERATORS_FIELDS_WORK_POPUP: 'getOrderGeneratorsFieldsWorkPopup',
		GET_ORDER_GENERATORS_FIELDS_WORK_RELATED_PLAN_WORKS: 'getOrderGeneratorsFieldsWorkRelatedPlanWorks',
	},
	[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS]: {
		GET_ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS: 'getOrderGeneratorsFieldsWorksPlanWorks',
		GET_ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORK: 'getOrderGeneratorsFieldsWorksPlanWork',
		CREATE_ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORK: 'createOrderGeneratorsFieldsWorksPlanWork',
		CREATE_ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORK_BULK: 'createOrderGeneratorsFieldsWorksPlanWorkBulk',
		PUT_ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORK: 'putOrderGeneratorsFieldsWorksPlanWork',
		PATCH_ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORK: 'patchOrderGeneratorsFieldsWorksPlanWork',
		DELETE_ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORK: 'deleteOrderGeneratorsFieldsWorksPlanWork',
		GET_ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORK_PREVIEW: 'getOrderGeneratorsFieldsWorksPlanWorkPreview',
		GET_ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORK_POPUP: 'getOrderGeneratorsFieldsWorksPlanWorkPopup',
		GET_ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS_RELATED_PLAN_WORKS: 'getOrderGeneratorsFieldsWorksPlanWorksRelatedPlanWorks',
	},
	[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS]: {
		GET_ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS: 'getOrderGeneratorsFieldsWorksExecutors',
		GET_ORDER_GENERATORS_FIELDS_WORKS_EXECUTOR: 'getOrderGeneratorsFieldsWorksExecutor',
		CREATE_ORDER_GENERATORS_FIELDS_WORKS_EXECUTOR: 'createOrderGeneratorsFieldsWorksExecutor',
		PUT_ORDER_GENERATORS_FIELDS_WORKS_EXECUTOR: 'putOrderGeneratorsFieldsWorksExecutor',
		PATCH_ORDER_GENERATORS_FIELDS_WORKS_EXECUTOR: 'patchOrderGeneratorsFieldsWorksExecutor',
		DELETE_ORDER_GENERATORS_FIELDS_WORKS_EXECUTOR: 'deleteOrderGeneratorsFieldsWorksExecutor',
		CREATE_ORDER_GENERATORS_FIELDS_WORKS_EXECUTOR_BULK: 'createOrderGeneratorsFieldsWorksExecutorBulk',
	},
	[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADES]: {
		GET_ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADES: 'getOrderGeneratorsFieldsWorksExecutorsBrigades',
		GET_ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADE: 'getOrderGeneratorsFieldsWorksExecutorsBrigade',
		CREATE_ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADE: 'createOrderGeneratorsFieldsWorksExecutorsBrigade',
		PUT_ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADE: 'putOrderGeneratorsFieldsWorksExecutorsBrigade',
		PATCH_ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADE: 'patchOrderGeneratorsFieldsWorksExecutorsBrigade',
		DELETE_ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADE: 'deleteOrderGeneratorsFieldsWorksExecutorsBrigade',
	},
	[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_MATERIALS]: {
		GET_ORDER_GENERATORS_FIELDS_WORKS_MATERIALS: 'getOrderGeneratorsFieldsWorksMaterials',
		GET_ORDER_GENERATORS_FIELDS_WORKS_MATERIAL: 'getOrderGeneratorsFieldsWorksMaterial',
		CREATE_ORDER_GENERATORS_FIELDS_WORKS_MATERIAL: 'createOrderGeneratorsFieldsWorksMaterial',
		PUT_ORDER_GENERATORS_FIELDS_WORKS_MATERIAL: 'putOrderGeneratorsFieldsWorksMaterial',
		PATCH_ORDER_GENERATORS_FIELDS_WORKS_MATERIAL: 'patchOrderGeneratorsFieldsWorksMaterial',
		DELETE_ORDER_GENERATORS_FIELDS_WORKS_MATERIAL: 'deleteOrderGeneratorsFieldsWorksMaterial',
	},
	[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_PRODUCTS]: {
		GET_ORDER_GENERATORS_FIELDS_WORKS_PRODUCTS: 'getOrderGeneratorsFieldsWorksProducts',
		GET_ORDER_GENERATORS_FIELDS_WORKS_PRODUCT: 'getOrderGeneratorsFieldsWorksProduct',
		CREATE_ORDER_GENERATORS_FIELDS_WORKS_PRODUCT: 'createOrderGeneratorsFieldsWorksProduct',
		PUT_ORDER_GENERATORS_FIELDS_WORKS_PRODUCT: 'putOrderGeneratorsFieldsWorksProduct',
		PATCH_ORDER_GENERATORS_FIELDS_WORKS_PRODUCT: 'patchOrderGeneratorsFieldsWorksProduct',
		DELETE_ORDER_GENERATORS_FIELDS_WORKS_PRODUCT: 'deleteOrderGeneratorsFieldsWorksProduct',
	},
	[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROLS]: {
		GET_ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROLS: 'getOrderGeneratorsFieldsWorksQualityControls',
		GET_ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROL: 'getOrderGeneratorsFieldsWorksQualityControl',
		CREATE_ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROL: 'createOrderGeneratorsFieldsWorksQualityControl',
		PUT_ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROL: 'putOrderGeneratorsFieldsWorksQualityControl',
		PATCH_ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROL: 'patchOrderGeneratorsFieldsWorksQualityControl',
		DELETE_ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROL: 'deleteOrderGeneratorsFieldsWorksQualityControl',
	},
	[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENTS]: {
		GET_ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENTS: 'getOrderGeneratorsFieldsWorksStaffPayments',
		GET_ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENT: 'getOrderGeneratorsFieldsWorksStaffPayment',
		CREATE_ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENT: 'createOrderGeneratorsFieldsWorksStaffPayment',
		PUT_ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENT: 'putOrderGeneratorsFieldsWorksStaffPayment',
		PATCH_ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENT: 'patchOrderGeneratorsFieldsWorksStaffPayment',
		DELETE_ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENT: 'deleteOrderGeneratorsFieldsWorksStaffPayment',
	},
	[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_SERVICES]: {
		GET_ORDER_GENERATORS_FIELDS_WORKS_SERVICES: 'getOrderGeneratorsFieldsWorksServices',
		GET_ORDER_GENERATORS_FIELDS_WORKS_SERVICE: 'getOrderGeneratorsFieldsWorksService',
		CREATE_ORDER_GENERATORS_FIELDS_WORKS_SERVICE: 'createOrderGeneratorsFieldsWorksService',
		PUT_ORDER_GENERATORS_FIELDS_WORKS_SERVICE: 'putOrderGeneratorsFieldsWorksService',
		PATCH_ORDER_GENERATORS_FIELDS_WORKS_SERVICE: 'patchOrderGeneratorsFieldsWorksService',
		DELETE_ORDER_GENERATORS_FIELDS_WORKS_SERVICE: 'deleteOrderGeneratorsFieldsWorksService',
	},
	[ModulesMap.LOGISTIC_ROUTES]: {
		GET_LOGISTIC_ROUTES: 'getLogisticRoutes',
		GET_LOGISTIC_ROUTE: 'getLogisticRoute',
		CREATE_LOGISTIC_ROUTE: 'createLogisticRoute',
		PUT_LOGISTIC_ROUTE: 'putLogisticRoute',
		PATCH_LOGISTIC_ROUTE: 'patchLogisticRoute',
		DELETE_LOGISTIC_ROUTE: 'deleteLogisticRoute',
		GET_LOGISTIC_ROUTE_POPUP: 'getLogisticRoutePopup',
		GET_LOGISTIC_ROUTE_PREVIEW: 'getLogisticRoutePreview',
	},
	[ModulesMap.LOGISTIC_ROUTES_GEO_ZONES]: {
		GET_LOGISTIC_ROUTES_GEO_ZONES: 'getLogisticRoutesGeoZones',
		GET_LOGISTIC_ROUTES_GEO_ZONE: 'getLogisticRoutesGeoZone',
		CREATE_LOGISTIC_ROUTES_GEO_ZONE: 'createLogisticRoutesGeoZone',
		PUT_LOGISTIC_ROUTES_GEO_ZONE: 'putLogisticRoutesGeoZone',
		PATCH_LOGISTIC_ROUTES_GEO_ZONE: 'patchLogisticRoutesGeoZone',
		DELETE_LOGISTIC_ROUTES_GEO_ZONE: 'deleteLogisticRoutesGeoZone',
		GET_LOGISTIC_ROUTES_GEO_ZONE_POPUP: 'getLogisticRoutesGeoZonePopup',
		GET_LOGISTIC_ROUTES_GEO_ZONE_PREVIEW: 'getLogisticRoutesGeoZonePreview',
	},
	[ModulesMap.REPORT_DEVICE_MOUNTS]: {
		GET_REPORT_DEVICE_MOUNTS: 'getReportDeviceMounts',
		GET_REPORT_DEVICE_MOUNT: 'getReportDeviceMount',
	},
	[ModulesMap.DONE_WORKS_ALL_FIELD_WORKS]: {
		GET_DONE_WORKS_ALL_FIELD_WORKS: 'getDoneWorksAllFieldWorks',
	},
	[ModulesMap.DONE_WORKS_ALL_LOGISTIC_WORKS]: {
		GET_DONE_WORKS_ALL_LOGISTIC_WORKS: 'getDoneWorksAllLogisticWorks',
	},
	[ModulesMap.DONE_WORKS_ALL_HAND_MADE_WORKS]: {
		GET_DONE_WORKS_ALL_HAND_MADE_WORKS: 'getDoneWorksAllHandMadeWorks',
	},
	[ModulesMap.REGULATIONS_ALL_PLAN_WORKS]: {
		GET_REGULATIONS_ALL_PLAN_WORKS: 'getRegulationsAllPlanWorks',
	},
	[ModulesMap.CARGOS]: {
		GET_CARGOS: 'getCargos',
		GET_CARGO: 'getCargo',
		GET_CARGO_PREVIEW: 'getCargoPreview',
		GET_CARGO_POPUP: 'getCargoPopup',
		CREATE_CARGO: 'createCargo',
		PUT_CARGO: 'putCargo',
		PATCH_CARGO: 'patchCargo',
		DELETE_CARGO: 'deleteCargo',
	},
	[ModulesMap.CARGO_ITEMS]: {
		GET_CARGO_ITEMS: 'getCargoItems',
		GET_CARGO_ITEM: 'getCargoItem',
		GET_CARGO_ITEM_PREVIEW: 'getCargoItemPreview',
		GET_CARGO_ITEM_POPUP: 'getCargoItemPopup',
		CREATE_CARGO_ITEM: 'createCargoItem',
		PUT_CARGO_ITEM: 'putCargoItem',
		PATCH_CARGO_ITEM: 'patchCargoItem',
		DELETE_CARGO_ITEM: 'deleteCargoItem',
	},
	[ModulesMap.CARGO_TAGS]: {
		GET_CARGO_TAGS: 'getCargoTags',
		GET_CARGO_TAG: 'getCargoTag',
		CREATE_CARGO_TAG: 'createCargoTag',
		PUT_CARGO_TAG: 'putCargoTag',
		PATCH_CARGO_TAG: 'patchCargoTag',
		DELETE_CARGO_TAG: 'deleteCargoTag',
	},
	[ModulesMap.API_USAGES]: {
		GET_API_USAGES: 'getApiUsages',
		GET_API_USAGE: 'getApiUsage',
		GET_API_USAGE_PREVIEW: 'getApiUsagePreview',
		GET_API_USAGE_POPUP: 'getApiUsagePopup',
	},
	[ModulesMap.LANDS]: {
		GET_LANDS: 'getLands',
		GET_LAND: 'getLand',
		GET_LAND_PREVIEW: 'getLandPreview',
		GET_LAND_POPUP: 'getLandPopup',
		CREATE_LAND: 'createLand',
		PUT_LAND: 'putLand',
		PATCH_LAND: 'patchLand',
		DELETE_LAND: 'deleteLand',
	},
	[ModulesMap.EQUIPMENT_DOCUMENTS]: {
		GET_EQUIPMENT_DOCUMENTS: 'getEquipmentDocuments',
		CREATE_EQUIPMENT_DOCUMENT: 'createEquipmentDocument',
		GET_EQUIPMENT_DOCUMENT: 'getEquipmentDocument',
		PATCH_EQUIPMENT_DOCUMENT: 'patchEquipmentDocument',
		PUT_EQUIPMENT_DOCUMENT: 'putEquipmentDocument',
		DELETE_EQUIPMENT_DOCUMENT: 'deleteEquipmentDocument',
	},
	[ModulesMap.EQUIPMENT_PLEDGES]: {
		GET_EQUIPMENT_PLEDGES: 'getEquipmentPledges',
		CREATE_EQUIPMENT_PLEDGE: 'createEquipmentPledge',
		GET_EQUIPMENT_PLEDGE: 'getEquipmentPledge',
		PATCH_EQUIPMENT_PLEDGE: 'patchEquipmentPledge',
		PUT_EQUIPMENT_PLEDGE: 'putEquipmentPledge',
		DELETE_EQUIPMENT_PLEDGE: 'deleteEquipmentPledge',
	},
	[ModulesMap.LANDS_CADASTRAL_CASES]: {
		GET_LANDS_CADASTRAL_CASES: 'getLandsCadastralCases',
		GET_LANDS_CADASTRAL_CASE: 'getLandsCadastralCase',
		GET_LANDS_CADASTRAL_CASE_PREVIEW: 'getLandsCadastralCasePreview',
		GET_LANDS_CADASTRAL_CASE_POPUP: 'getLandsCadastralCasePopup',
		CREATE_LANDS_CADASTRAL_CASE: 'createLandsCadastralCase',
		PUT_LANDS_CADASTRAL_CASE: 'putLandsCadastralCase',
		PATCH_LANDS_CADASTRAL_CASE: 'patchLandsCadastralCase',
		DELETE_LANDS_CADASTRAL_CASE: 'deleteLandsCadastralCase',
	},
	[ModulesMap.CUSTOM_GEO_ZONES]: {
		GET_CUSTOM_GEO_ZONES: 'getCustomGeoZones',
		GET_CUSTOM_GEO_ZONE: 'getCustomGeoZone',
		GET_CUSTOM_GEO_ZONE_PREVIEW: 'getCustomGeoZonePreview',
		GET_CUSTOM_GEO_ZONE_POPUP: 'getCustomGeoZonePopup',
		CREATE_CUSTOM_GEO_ZONE: 'createCustomGeoZone',
		PUT_CUSTOM_GEO_ZONE: 'putCustomGeoZone',
		PATCH_CUSTOM_GEO_ZONE: 'patchCustomGeoZone',
		DELETE_CUSTOM_GEO_ZONE: 'deleteCustomGeoZone',
	},
	[ModulesMap.CUSTOM_GEO_ZONES_CATEGORIES]: {
		GET_CUSTOM_GEO_ZONES_CATEGORIES: 'getCustomGeoZonesCategories',
		GET_CUSTOM_GEO_ZONES_CATEGORY: 'getCustomGeoZonesCategory',
		CREATE_CUSTOM_GEO_ZONES_CATEGORY: 'createCustomGeoZonesCategory',
		PUT_CUSTOM_GEO_ZONES_CATEGORY: 'putCustomGeoZonesCategory',
		PATCH_CUSTOM_GEO_ZONES_CATEGORY: 'patchCustomGeoZonesCategory',
		DELETE_CUSTOM_GEO_ZONES_CATEGORY: 'deleteCustomGeoZonesCategory',
	},
	[ModulesMap.REGULATIONS_STAFF_ROLES_INFO]: {
		GET_REGULATIONS_STAFF_ROLES_INFO: 'getRegulationsStaffRolesInfo',
	},
	[ModulesMap.BUSINESS_PROCESS_BASE_EXECUTORS]: {
		GET_BUSINESS_PROCESS_BASE_EXECUTORS: 'getBusinessProcessBaseExecutors',
		CREATE_BUSINESS_PROCESS_BASE_EXECUTOR: 'createBusinessProcessBaseExecutor',
		GET_BUSINESS_PROCESS_BASE_EXECUTOR: 'getBusinessProcessBaseExecutor',
		PUT_BUSINESS_PROCESS_BASE_EXECUTOR: 'putBusinessProcessBaseExecutor',
		PATCH_BUSINESS_PROCESS_BASE_EXECUTOR: 'patchBusinessProcessBaseExecutor',
		DELETE_BUSINESS_PROCESS_BASE_EXECUTOR: 'deleteBusinessProcessBaseExecutor',
		GET_BUSINESS_PROCESS_BASE_EXECUTOR_PREVIEW: 'getBusinessProcessBaseExecutorPreview',
		GET_BUSINESS_PROCESS_BASE_EXECUTOR_POPUP: 'getBusinessProcessBaseExecutorPopup',
	},
}

// This config contains data generation METHODS NAMES
// for specific module
export const MockMethodsMap = {
	[ModulesMap.CACHE]: {
		GET_CACHE_HASHES: 'generateCashHashes',
	},
	[ModulesMap.USER]: {
		GET_CURRENT_USER: 'generateCurrentUser',
		GET_PERMISSIONS: 'generateUserPermissions',
	},
	[ModulesMap.AUTH]: {
		LOGIN: 'login',
		REGISTER: 'register',
		LOGOUT: 'logout',
	},
	[ModulesMap.PRESETS]: {
		GET_PRESETS: 'getPresetes',
		RESTORE_BASE_PRESETS: 'restoreBasePresets',
		DELETE_PRESET: 'deletePreset',
		EDIT_PRESET: 'editPreset',
		CREATE_PRESET: 'createPreset',
		CHANGE_PRESETS_ORDER: 'changePresetsOrder',
	},
}
